import pleaseWait from "please-wait";
window.pleaseWait = pleaseWait.pleaseWait;
